import { type IPhoneStrictSchema } from '@/repositories/generated/shared/search-offers/entities/phone/PhoneStrictSchema';

export function formatPhone(phone: IPhoneStrictSchema): string {
  let formattedPhone = `${phone.countryCode}${phone.number}`.replace(
    /(\d)(\d{3})(\d{3})(\d{2})(\d{2})/,
    '$1 $2 $3-$4-$5',
  );

  if (/^\d/.test(formattedPhone)) {
    formattedPhone = `+${formattedPhone}`;
  }

  return formattedPhone;
}
